import { render, staticRenderFns } from "./cotizacion.vue?vue&type=template&id=50990a84&scoped=true&"
import script from "./cotizacion.vue?vue&type=script&lang=js&"
export * from "./cotizacion.vue?vue&type=script&lang=js&"
import style0 from "./cotizacion.vue?vue&type=style&index=0&id=50990a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50990a84",
  null
  
)

export default component.exports